import { Button, Card, Space, Table } from "antd"
import { centsToDollarsDisplay } from "../../displayFormatters"
import { getProjectUrl } from "../datacenterModel"
import { InvoiceReportData } from "./invoiceReportApi"
import ExportCsvButton from "../ExportCsvButton"
import useDashboardReporting from "../../../hooks/useDashboardReporting"
import { CsvDateRange } from "../reportCsvExport"
import { invoiceExportColumns, invoiceExportRows } from "./invoiceReportExport"
import { projectTypeName } from "../../../common/constants"
import { useState } from "react"
import dayjs from 'dayjs';

type FiltersListItem = {
  id: string
  value: string
}

const filtersList: FiltersListItem[] = [
  { id: 'unbilled', value: 'Unbilled' },
  { id: 'outstanding', value: 'Outstanding' },
  { id: 'paid', value: 'Paid' },
]

type Props = {
  invoices: InvoiceReportData[]
  dateRange: CsvDateRange
}

const InvoiceReportInvoicesList = ({ invoices, dateRange }: Props) => {
  const dashboardReporting = useDashboardReporting()
  const [activeFilter, setActiveFilter] = useState<string>('unbilled');
  const filteredInvoices = invoices.filter(invoice => {
    if (activeFilter === 'unbilled') {
      return invoice.unbilledAmount !== 0
    } else if (activeFilter === 'outstanding') {
      return invoice.invoiceBalance !== 0
    }
    return invoice.totalInvoicedAmount - invoice.totalInvoiceBalance !== 0
  })

  
  return <Card
    extra={dashboardReporting && <ExportCsvButton reportName='Invoicing' dateRange={dateRange} columns={invoiceExportColumns} rows={invoiceExportRows(invoices)} tooltip='Exports every tab: each amount is its own column' />}
    title={<Space>
      {
        filtersList.map((filter) => <Button
            key={filter.id}
            shape='round'
            type={activeFilter === filter.id ? 'primary' : 'default'}
            onClick={() => setActiveFilter(filter.id)}
          >
            {filter.value}
          </Button>
        )
      }
    </Space>}
  >
    <Table
      dataSource={filteredInvoices}
      rowKey="jobId"
      pagination={{ showSizeChanger: true }}
      columns={[
        {
          title: 'Project Name',
          dataIndex: 'name',
        },
        {
          title: 'Job Type',
          dataIndex: 'jobType',
          render: (_, record) => projectTypeName(record.jobType)
        },
        {
          title: 'Customer',
          dataIndex: 'customerDisplayName',
        },
        {
          title: 'Not Invoiced Total',
          dataIndex: 'unbilledAmount',
          render: (_, record) => `${centsToDollarsDisplay(record.unbilledAmount)}`
        },
        {
          title: 'Outstanding Total',
          dataIndex: 'invoiceBalance',
          render: (_, record) => `${centsToDollarsDisplay(record.invoiceBalance)}`
        },
        {
          title: 'Paid Price',
          dataIndex: 'finalPrice',
          render: (_, record) => {
            const paidTotal = record.totalInvoicedAmount - record.totalInvoiceBalance

            return `${centsToDollarsDisplay(Math.max(paidTotal))}`
          }
        },
        {
          title: 'Last Invoice Date',
          dataIndex: 'lastInvoiceDate',
          render: (_, record) => {
            return record.lastInvoiceDate ? `${dayjs(record.lastInvoiceDate).format('MM/DD/YYYY')}` : ''
          }
        }
      ]}
      onRow={(record) => {
        const jobUrl = getProjectUrl(record.jobId, record.jobType, record.sold, record.name)

        return {
          onClick: () => window.open(`#!/${jobUrl}`, '_blank'),
          style: { cursor: 'pointer' }
        }
      }}
    />
  </Card>
}

export default InvoiceReportInvoicesList